import { render } from "./DashboardNavbar.vue?vue&type=template&id=213492b6&scoped=true&ts=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=ts"
export * from "./DashboardNavbar.vue?vue&type=script&lang=ts"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=213492b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213492b6"]])

export default __exports__